import { render, staticRenderFns } from "./CabinetsContract.vue?vue&type=template&id=ceeacfc6&"
import script from "./CabinetsContract.vue?vue&type=script&lang=js&"
export * from "./CabinetsContract.vue?vue&type=script&lang=js&"
import style0 from "./CabinetsContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CabinetsContract.vue"
export default component.exports